import { Box } from '@opendoor/bricks-next';
import type { BoxProps } from '@opendoor/bricks-next';
import type { EntryComponent } from 'cms/entries/entries';
import type { ILpComponentSpacer } from 'declarations/contentful';

import { getComponentThemeColors } from './shared/styles/ComponentTheme';

const bricksBgToToken: Record<string, BoxProps['backgroundColor']> = {
  white0: '$backgroundPrimary',
  warmgrey100: '$backgroundSecondary',
  earth100: '$backgroundSecondary',
  earth200: '$backgroundTertiary',
  brandBlue600: '$backgroundAccentBrand',
  warmgrey200: '$backgroundTertiary',
  warmgrey800: '$backgroundInversePrimary',
  warmgrey950: '$backgroundInversePrimary',
  neutrals100: '$backgroundInversePrimary',
};

const RenderSpacer = (entry: ILpComponentSpacer) => {
  const { fields } = entry;
  const componentTheme = fields.backgroundColor
    ? getComponentThemeColors(fields.backgroundColor)
    : getComponentThemeColors('White 0');

  const bgColor = componentTheme.bg ? String(componentTheme.bg) : 'white0';
  const bgToken = bricksBgToToken[bgColor] || '$backgroundPrimary';
  const mobileHeight = parseInt(fields.mobileSpace, 10);
  // `!= null` so an authored desktop "0" stays 0 rather than inheriting mobile.
  const desktopHeight = fields.space != null ? parseInt(fields.space, 10) : mobileHeight;

  return (
    <Box
      display="block"
      className="lp-spacer"
      backgroundColor={bgToken}
      aria-hidden
      height={mobileHeight}
      $largerThanSM={{ height: desktopHeight }}
    />
  );
};

const Spacer: EntryComponent<ILpComponentSpacer> = {
  render: RenderSpacer,
};

export default Spacer;
